<div class="modal-body">
  <div class="row mb-4">
    <div class="col d-flex justify-content-between">
      <span class="font-weight-500">Add Company</span>
      <span type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
      (click)="clearModal()">
      <i class="fas fa-times f-16 text-black"></i>
    </span>
    </div>
  </div>
  <div>
    <app-webbtree-company-search (keywordSearchInput)="getCompanySearch($event)" [searchFrom]="'modal'"></app-webbtree-company-search>

  </div>
  <app-webbtree-company-filters [totalCompanies]="formatNumberToIndianFormat(totalCompanies)"></app-webbtree-company-filters>

  <div class="scroll-widget px-2" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
  [scrollWindow]="false" (scrolled)="getRecommendation('pagination')" >
    <div *ngIf="!companyListLoader">
      <div class="mb-2" style="border-bottom: 1px solid #D9D9D9;" *ngFor="let company of companiesList">
        <div class="pb-2" >
          <div class="d-flex">
              <div class="compLogoIcon mr-3 bg-gray-new">
                <i class="fa-solid fa-buildings text-webbtree-green" *ngIf="!company?.companylogo"></i>
                <img [src]="company?.companylogo" alt="company?.name" *ngIf="company?.companylogo">
              </div>
              <div class="d-flex justify-content-between w-100">
                <div class="w-100">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex">
                          <div class="">
                            <p class="f-14 font-weight-500 text-484b59 mb-1" *ngIf="company?.name">{{company?.name |
                              titlecase}}</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p class="f-12 text-9696 mb-0 font-weight-400" *ngIf="company?.industry">{{company?.industry | titlecase}}
                        </p>

                      </div>
                </div>

                    <div class="d-flex align-items-center h-100" >
                     <button data-testid="auto-app-add-company-modal-button-1" class="btn-trms-regular" (click)="addCompanyForCompare(company)" [ngClass]="{'disable-compare': getDisabledCompareButton(company.id)}">
                        +Add
                      </button>
                    </div>
              </div>
        </div>
      </div>
      </div>
    </div>
    <div class="shimmer-wrapper" *ngIf="companyListLoader">
      <!-- Repeat shimmer items to match the number in the image -->
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>

          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>
          <div class="shimmer-item">
            <div class="shimmer-logo"></div>
            <div class="shimmer-text">
              <div class="shimmer-text-line"></div>
              <div class="shimmer-text-line"></div>
            </div>
            <div class="shimmer-button"></div>
          </div>

      <!-- Repeat as needed... -->
        </div>
  </div>

  </div>
